enum NotificationTab {

    All = "all",
    Unread = "unread"
}
export {
    NotificationTab
};
